import { render, staticRenderFns } from "./mobileJoin.vue?vue&type=template&id=c2caae74&scoped=true"
import script from "./mobileJoin.vue?vue&type=script&lang=js"
export * from "./mobileJoin.vue?vue&type=script&lang=js"
import style0 from "./mobileJoin.vue?vue&type=style&index=0&id=c2caae74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2caae74",
  null
  
)

export default component.exports